import { Injectable, Injector } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';
import { PackageService } from '../packages/package.service';
import { DynamicContentService } from './dynamic-content.service';
import { MessengerService } from '../messenger/messenger.service';
import { PackageInstalledAppsService } from '../packages/package-installed-apps.service';

@Injectable()
export class DynamicContentEntranceService extends RestfulService<Models.DynamicContentEntrance> {

  constructor(
    private restService: RestService,
    private ms: MessengerService,
    private injector: Injector
  ) {
    super(Models.DynamicContentEntrance);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('dynamic-content-entrances');
  }

  // we can get all assigned stuff from dynamic-content-entrance-id: packages, compositions, installedApps
  // services are injected - calling component has to import these services

  public async findAssigned(skip: number, limit: number, params?: any, options?: any): Promise<any> {
    let installedApp;
    const entrances = await super.find(skip, limit, params ? params : null);
    if (entrances?.data?.length) {
      const appQuery = { dynamicContentEntranceId: { $in: entrances.data.map(el => el._id) } };

      if (options && options.packageIds) {
        appQuery['packageId'] = { $in: options.packageIds };
      }

      const installedApps = await this.injector.get(PackageInstalledAppsService).find(0, 100, appQuery);
      if (!installedApps || !installedApps.data || !installedApps.data.length) {
        throw Error('Entrances are not assigned to any app');
      }
      const packageIds = Array.from(new Set(installedApps.data.map(item => item.packageId)));
      const packages = await this.injector.get(PackageService).find(0, 100, { _id: { $in: packageIds } });
      if (!packages || !packages.data.length || !packages.data.length) {
        throw Error('Entrances are not assigned to any package');
      }

      const activeEntrances = [];
      const activePackages = [];

      packages.data.map(myPackage => {
        if (packageIds.includes(myPackage._id)) {
          myPackage.installedAppIds.map(id => {
            const app = installedApps.data.find(el => id === el._id);

            if (app && app.dynamicContentEntranceId) {
              installedApp = app;
              if (!activePackages.find(el => el._id === myPackage._id)) {
                activePackages.push(myPackage);
              }

              const index = entrances.data.findIndex(item => item['_id'] === app.dynamicContentEntranceId);
              const activeEntrance = index > -1 ? entrances.data.splice(index, 1)[0] : null;

              if (activeEntrance) {
                activeEntrance['translations'] = app.translations;
                activeEntrance['isSecured'] = app.isSecured;
                activeEntrances.push(activeEntrance);
              }
            }
          });
        }
      });

      if (!activeEntrances || !activeEntrances.length) {
        throw Error('There are no active entrances');
      }

      return { packages: activePackages, entrances: activeEntrances, installedApp }
    } else {
      throw Error('No entrances found for: ' + JSON.stringify(params));
    }
  }

  // return entrance or dynamic-content by id

  public async getParent(query, level = 0): Promise<any> {
    let result: any;
    try {
      result = await this.findAssigned(0, 1, query);
      return {
        entrance: result.entrances[0], availableLanguages: result.packages[0].availableLanguagesCached,
        masterLanguage: result.packages[0].masterLanguageCached, installedApp: result.installedApp
      };
    } catch (err) {
      const subParent = await this.injector.get(DynamicContentService).find(0, 1, query);
      if (!subParent.data[0]) {
        throw Error('no parent found');
      }
      if (query._id && subParent.data[0]._id && query._id === subParent.data[0]._id && level !== 0) {
        const alternativeSubParent = await this.injector.get(DynamicContentService).find(0, 1, { children: query._id });
        if (alternativeSubParent?.data && alternativeSubParent.data[0]) {
          return { content: alternativeSubParent.data[0] };
        }
      }
      return { content: subParent.data[0] };
    }
  }

}

